/**
 * Calculate status check threshold (minutes) based on incident type and source.
 * Shared between Dashboard and MobileDashboard.
 *
 * @param {string} incidentType
 * @param {string} source
 * @param {{ defaultMinutes: number, overrides: Record<string, number> }} settings
 * @returns {number} threshold in minutes
 */
export const getStatusCheckThreshold = (incidentType, source, settings) => {
  if (!incidentType) {
    return settings.defaultMinutes;
  }

  const key = String(incidentType).trim().toLowerCase();
  const sourceKey = source ? String(source).trim().toLowerCase() : '';

  // Special case: Service Call source with Assist Motorist = 10 hours (600 minutes)
  if (key === 'assist motorist' && sourceKey === 'service call') {
    return 600;
  }

  return settings.overrides[key] ?? settings.defaultMinutes;
};
